import { useEffect } from "react";
import { useLocation } from "nystem-components";

const PartScrollTopOnNavigate = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};
export default PartScrollTopOnNavigate;
